import type { Messages } from "./nl";

// The words of the customer portal, English (British: the customers are in Europe).

export const en: Messages = {
  "portal.name": "Customer portal",

  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.copy": "Copy",
  "common.copied": "Copied",
  "common.backToSignIn": "Back to sign in",

  "language.choose": "Choose language",

  "nav.label": "Portal",
  "nav.home": "To Shipments",
  "nav.shipments": "Shipments",
  "nav.order": "Enter order",
  "nav.stock": "Stock",
  "nav.warehouseOrders": "Warehouse orders",

  "login.title": "Sign in",
  "login.lead": "Willems Logistics customer portal",
  "login.email": "E-mail address",
  "login.password": "Password",
  "login.forgot": "Forgot your password?",
  "login.submit": "Sign in",
  "login.noAccount": "No account yet? Your contact person at Willems invites you.",

  "code.title": "Code from the app",
  "code.lead": "Open the authenticator app and type the code shown for Willems Logistics.",
  "code.leadApp": "Open the app. Under Willems Logistics there is a six-digit code.",
  "code.label": "Code from the app",
  "code.noPhone": "Phone not at hand? Use a recovery code",
  "code.changes": "The code changes every 30 seconds. A code that has just expired still works.",
  "code.timeTip": "Code not accepted? Check that the time on your phone is set automatically. If it is set by hand, the code runs behind.",
  "code.scanAgain": "Scan again",
  "code.confirm": "Confirm",

  "recovery.back": "Back to the code",
  "recovery.title": "Sign in with a recovery code",
  "recovery.lead": "Use one of the eight codes you kept when you activated your account. Each code works once.",
  "recovery.label": "Recovery code",
  "recovery.thenPhone": "After signing in, the portal asks you to link a new phone straight away. Your old link then stops working.",
  "recovery.noneLeft":
    "No codes left? Contact your contact person at Willems. Willems sets up your access again: you receive a new invitation and choose a password and a phone again.",

  "locked.title": "Locked for a while",
  "locked.text": "Your account is locked for a quarter of an hour. A wrong password or a wrong code was entered five times in a row. You can sign in again at {{time}}.",
  "locked.notYou": "Was that not you? Then change your password after signing in, in the menu under your name.",

  "forgot.title": "Forgot your password",
  "forgot.lead": "You receive a mail with a link to choose a new password.",
  "forgot.submit": "Send link",
  "forgot.sent": "Check your mail. If we know this address, the link arrives within a few minutes. It works for one hour. No mail? Also look in your junk mail.",
  "forgot.codeToo": "For the new password the portal also asks the code from your authenticator app. A mailbox alone is not enough to get into your account.",

  "reset.title": "New password",
  "reset.submit": "Save and sign in",
  "reset.elsewhere": "After saving you are signed out everywhere else.",
  "reset.noPhone": "Lost your phone as well? Then you cannot choose a new password here. Your contact person at Willems sets up your access again.",

  "link.invalidTitle": "This link no longer works",
  "link.invalidInvitation":
    "The link in the invitation works once, for seven days. Is your account set up already? Then sign in. Otherwise ask your contact person at Willems for a new invitation.",
  "link.invalidReset": "The link for a new password works once, for one hour. Ask for a new link.",
  "link.toSignIn": "To sign in",
  "link.askNew": "Ask for a new link",

  "password.new": "New password",
  "password.current": "Current password",
  "password.repeat": "Once more",
  "password.ruleLength": "At least 10 characters",
  "password.ruleEmail": "Not your e-mail address",
  "password.tooShort": "Choose a password of at least 10 characters.",
  "password.sameAsEmail": "Your e-mail address cannot be a password.",
  "password.sameAsCurrent": "Choose a password other than the current one.",
  "password.notSame": "The two passwords are not the same.",

  "activate.label": "Activate account",
  "activate.steps": "Steps",
  "activate.stepPassword": "Password",
  "activate.stepApp": "Link the app",
  "activate.stepCode": "Check the code",
  "activate.stepCodes": "Recovery codes",
  "activate.passwordTitle": "Choose a password",
  "activate.passwordLead": "For {{email}} · {{companies}}",
  "activate.passwordTip": "Tip: a sentence of a few words is easier to remember than a code.",
  "activate.startedBefore": "You started here before. Choose a password again; then you link the app.",
  "activate.nextApp": "Next: link the app",
  "activate.nextCode": "Next: check the code",
  "activate.codeTitle": "Type the code from the app",
  "activate.linked": "The app is linked.",
  "activate.toPortal": "To the portal",

  "app.title": "Link the authenticator app on your phone",
  "app.lead": "Every time you sign in, the portal asks for a six-digit code from this app. That way nobody else can sign in, not even with your password.",
  "app.step1": "Install an authenticator app",
  "app.step1Help": "For example Microsoft Authenticator or Google Authenticator: free in the App Store or Google Play. If you have one already, use it.",
  "app.step2": "Tap + in the app",
  "app.step2Help": "Choose Add account and then Scan QR code. If it says work or school account, choose other account.",
  "app.step3": "Point the camera at the QR code next to this",
  "app.step3Help": "Willems Logistics appears in the app with a six-digit code.",
  "app.keyDesk": "Scanning does not work? Choose enter code in the app and type this key:",
  "app.keyPhone": "Nothing happens? Copy the key and paste it in the app under enter code:",
  "app.phoneInstall": "Install Microsoft Authenticator or Google Authenticator, if you do not have it yet.",
  "app.phoneAdd": "Add to the authenticator app",
  "app.phoneBack": "Then come back to this screen and type the six-digit code.",
  "app.qrLabel": "QR code to add the account to the authenticator app",
  "app.print": "Print these instructions",

  "codes.title": "Keep your recovery codes",
  "codes.lead": "Lose your phone, or get a new one? Then you sign in with one of these codes and link the new phone afterwards. Each code works once.",
  "codes.leadNew": "These are your new recovery codes. The codes from before no longer work. Each code works once.",
  "codes.listLabel": "Recovery codes",
  "codes.download": "Download",
  "codes.print": "Print",
  "codes.where":
    "Do not keep them only on the same phone: in the drawer of your desk, or in your company's password vault. You see them here only once; you can make new ones later in the menu under your name.",
  "codes.kept": "I have kept my recovery codes",
  "codes.noneLeft": "No codes left and phone lost? Then Willems sets up your access again.",
  "codes.fileName": "willems-recovery-codes.txt",
  "codes.fileHead": "Willems Logistics - customer portal",
  "codes.fileFor": "Recovery codes for {{email}}",
  "codes.fileMade": "Made on {{at}}",
  "codes.fileOnce": "Each code works once.",

  "phone.title": "Link a new phone",
  "phone.stepLabel": "New phone",
  "phone.lead": "Your current phone keeps working until the code of the new phone is right.",
  "phone.leadForced": "You signed in with a recovery code. Now link the phone you will sign in with from now on; the old link then stops working.",
  "phone.leadPassword": "First type your password. Your current phone keeps working until the code of the new phone is right.",
  "phone.next": "Next: link the app",
  "phone.done": "The new phone is linked. You are signed out on other devices.",
  "phone.doneTitle": "Done",
  "phone.doneLead_one": "You have {{count}} recovery code left. Make new codes in the menu under your name.",
  "phone.doneLead_other": "You have {{count}} recovery codes left. You can make new ones in the menu under your name.",

  "company.title": "Which company are you working for now?",
  "company.lead_one": "You have access for {{count}} company.",
  "company.lead_other": "You have access for {{count}} companies. You see one company at a time; you can switch at the top, next to your name.",
  "company.signedInAs": "Signed in as {{name}} · {{email}}",
  "company.switch": "Choose another company",
  "company.youWorkFor": "You work for",
  "company.switchNote": "Switching loads the portal again, with only that company's data.",

  "user.menu": "User menu",
  "user.language": "Language",
  "user.password": "Change password",
  "user.phone": "Link a new phone",
  "user.recoveryCodes": "New recovery codes",
  "user.signOut": "Sign out",

  "account.passwordDone": "Your password has been changed. You are signed out on other devices.",
  "account.passwordElsewhere": "After saving you are signed out everywhere else.",
  "account.backToPortal": "Back to the portal",
  "account.codesLead_one": "You have {{count}} recovery code left. Make eight new ones; that one then stops working.",
  "account.codesLead_other": "You have {{count}} recovery codes left. Make eight new ones; the codes you have now then stop working.",
  "account.codesSubmit": "Make new codes",

  "expired.title": "You have been signed out",
  "expired.text": "The portal signs you out after 8 hours, and also when your password or access has changed.",
  "expired.again": "Sign in again",

  "problem.notFound": "This page does not exist, or you do not have access to it",
  "problem.notFoundText": "Did you come through a link from a colleague? It may belong to another company.",
  "problem.toShipments": "To Shipments",
  "problem.failure": "Something went wrong at Willems",
  "problem.failureText": "Please try again. If it still does not work, contact your contact person.",
  "problem.failureCode": "Please try again. If it still does not work, quote code {{code}} to your contact person.",
  "problem.retry": "Try again",

  "shipment.eyebrow": "Shipment",
  "shipment.yourReference": "Your reference {{reference}}",
  "shipment.entered.portal": "Entered in the portal, {{at}}",
  "shipment.entered.edi": "Received by EDI, {{at}}",
  "shipment.entered.willems": "Entered by Willems, {{at}}",
  "shipment.ownPage": "Own page",
  "shipment.close": "Close",
  "shipment.status.waiting": "Waiting for Willems",
  "shipment.status.rejected": "Rejected",
  "shipment.status.confirmed": "Confirmed",
  "shipment.status.planned": "Planned",
  "shipment.status.in_transit": "In transit",
  "shipment.status.delivered": "Delivered",
  "shipment.status.refused": "Refused",
  "shipment.status.cancelled": "Cancelled",
  "shipment.issue.shortage": "Shortage",
  "shipment.issue.damage": "Damage",
  "shipment.waiting.title": "Willems is checking this order before it goes ahead.",
  "shipment.waiting.address": "An address is new to Willems. Willems checks it and records it.",
  "shipment.waiting.stops": "The order of loading and unloading is not right. Willems corrects it or contacts you.",
  "shipment.waiting.duplicate": "There seems to be an identical order already. Willems checks whether it is the same one.",
  "shipment.waiting.too_late": "The order came in after the cut-off time. Willems checks whether it can still be done.",
  "shipment.waiting.account": "Your company is not quite set up at Willems yet. Willems arranges this and then releases the order.",
  "shipment.waiting.change": "A change has come in that Willems is still looking at.",
  "shipment.waiting.announced": "The order has been announced. Willems is waiting for the final details.",
  "shipment.waiting.check": "Willems is checking the order.",
  "shipment.rejected": "Willems cannot carry out this order. Please contact your contact person.",
  "shipment.cancelled": "This shipment has been cancelled.",
  "shipment.refused": "The consignee refused the goods.",
  "shipment.issueSentence.shortage": "Delivered with a shortage.",
  "shipment.issueSentence.damage": "Delivered with damage.",
  "shipment.remark": "Note: {{remark}}",
  "shipment.late": "Delivered after the time window.",
  "shipment.afterWindow": "after the window",
  "shipment.progress": "Progress",
  "shipment.step.entered": "Entered",
  "shipment.step.confirmed": "Confirmed",
  "shipment.step.planned": "Planned",
  "shipment.step.loaded": "Loaded",
  "shipment.step.delivered": "Delivered",
  "shipment.step.completed": "Completed",
  "shipment.load": "Loading",
  "shipment.unload": "Unloading",
  "shipment.placeReference": "Reference {{reference}}",
  "shipment.loadedAt": "Loaded {{at}}",
  "shipment.deliveredAt": "Unloaded {{at}}",
  "shipment.cargo.title": "Cargo",
  "shipment.cargo.description": "Description",
  "shipment.cargo.pallets": "Pallets",
  "shipment.cargo.weight": "Weight",
  "shipment.cargo.loadingMeters": "Loading metres",
  "shipment.cargo.adr": "ADR",
  "shipment.cargo.yes": "Yes",
  "shipment.cargo.temperature": "Temperature",
  "shipment.documents": "Documents",
  "shipment.cmrNotYet": "CMR not in yet",
  "shipment.cmrAfterDelivery": "The signed CMR appears here after delivery.",
  "shipment.cmrAfterHandIn": "The signed CMR appears here as soon as Willems has it.",
  "shipment.cmrSigned": "Signed CMR",
  "shipment.packingSlip": "Packing slip",
  "shipment.slipStoring": "being saved…",
  "shipment.slipHelp": "A PDF up to 10 MB, at most two per shipment, until the shipment is unloaded.",
  "shipment.slipClosed": "This shipment has been unloaded: a packing slip can no longer be added.",
  "shipment.cmrReceived": "received {{day}}",
  "shipment.download": "Download",

  "shipments.views": "Which shipments",
  "shipments.view.active": "Active",
  "shipments.view.waiting": "Waiting for Willems",
  "shipments.view.delivered": "Delivered",
  "shipments.view.all": "All",
  "shipments.search": "Reference, order number or town",
  "shipments.periodFrom": "From",
  "shipments.periodTo": "Up to and including",
  "shipments.excel": "Excel",
  "shipments.col.shipment": "Shipment",
  "shipments.col.from": "From",
  "shipments.col.to": "To",
  "shipments.col.load": "Loading",
  "shipments.col.unload": "Unloading",
  "shipments.col.cargo": "Cargo",
  "shipments.col.status": "Status",
  "shipments.col.cmr": "CMR",
  "shipments.pallets_one": "{{n}} pallet",
  "shipments.pallets_other": "{{n}} pallets",
  "shipments.cmrNotYet": "not yet",
  "shipments.cmrNotYetLong": "CMR not in yet",
  "shipments.cmrAvailable": "CMR",
  "shipments.cmrAvailableLong": "CMR in",
  "shipments.cmrDownload": "Download the signed CMR of {{number}}",
  "shipments.pickOne": "Select {{number}}",
  "shipments.pickAll": "Select all shipments in the list",
  "shipments.selected_one": "{{count}} selected",
  "shipments.selected_other": "{{count}} selected",
  "shipments.selectedWithCmr_one": "{{count}} with a CMR",
  "shipments.selectedWithCmr_other": "{{count}} with a CMR",
  "shipments.downloadCmrs": "Download CMRs",
  "shipments.clearSelection": "Clear selection",
  "shipments.cmrZipMax": "At most {{max}} CMRs at once; please select fewer.",
  "shipments.more": "Show more",
  "shipments.loadingMore": "Fetching more …",
  "shipments.notFound": "Nothing found for “{{q}}” in {{view}}",
  "shipments.notFoundText": "Search in All to include delivered and cancelled shipments too.",
  "shipments.notFoundAll": "Try another word or another period.",
  "shipments.searchAll": "Search in All",
  "columns.sortBy": "Sort by {{column}}",
  "columns.filterBy": "Filter on {{column}}",
  "columns.filteredBy": "Filtered on {{column}}: click to change the filter",
  "columns.filterContains": "Contains…",
  "columns.filterRangeFrom": "From",
  "columns.filterRangeTo": "Up to and including",
  "columns.filterFrom": "from {{value}}",
  "columns.filterUntil": "up to {{value}}",
  "columns.filterClear": "Clear",
  "columns.filterDone": "Done",
  "columns.filteredOn": "Filtered on",
  "columns.filterRemove": "Remove the filter on {{column}}",
  "columns.filterClearAll": "Clear all filters",
  "shipments.palletsUnit": "pallets",
  "shipments.notFiltered": "No shipments with these filters in {{view}}",
  "shipments.notFilteredText": "Remove a filter, or look in All.",
  "shipments.emptyTitle": "No shipments yet",
  "shipments.emptyText": "An order you enter here, or one that comes in by EDI, appears here as soon as Willems has it.",
  "shipments.none.active": "No shipments on the way or coming up",
  "shipments.none.waiting": "Nothing is waiting for Willems",
  "shipments.none.delivered": "Nothing delivered in this period",
  "shipments.none.all": "No shipments in this period",


  "shipment.entered.portalBy": "Entered in the portal by {{name}}, {{at}}",
  "order.steps": "Steps",
  "order.step.stops": "Loading and unloading",
  "order.step.goods": "Cargo",
  "order.step.documents": "Documents",
  "order.step.check": "Check",
  "order.step.toFill": "still to fill in",
  "order.step.willWait": "awaiting Willems",
  "order.step.willConfirm": "confirmed straight away",
  "order.step.more_one": "{{count}} more shipment",
  "order.step.more_other": "{{count}} more shipments",
  "order.step.lines_one": "{{count}} line",
  "order.step.lines_other": "{{count}} lines",
  "order.step.cmrDefault": "your company and the unloading address",
  "order.step.slips_one": "{{count}} packing slip",
  "order.step.slips_other": "{{count}} packing slips",
  "order.step.cmrOther": "another sender or consignee",
  "order.titleChange": "Change order {{number}}",
  "order.forCompany": "For {{company}}",
  "order.reference": "Your reference",
  "order.referenceHelp": "Goes on the CMR and the invoice.",
  "order.required": "Please fill this in.",
  "order.optional": "(optional)",
  "order.consignmentN": "Shipment {{n}}",
  "order.missing.stops": "Choose an address and a date for loading and unloading; unloading is not before loading.",
  "order.missing.address": "Choose an address above.",
  "order.missing.addressTyped": "Fill in at least the name, the city and the country.",
  "order.missing.date": "Choose a date.",
  "order.missing.beforeLoad": "Unloading is not before loading.",
  "order.missing.goods": "Give a number on every line, and the loading metres for roll containers, boxes and other goods. A description is welcome but not required.",
  "order.address.name": "Name",
  "order.address.street": "Street",
  "order.address.houseNumber": "Number",
  "order.address.addition": "Addition",
  "order.address.postalCode": "Postcode",
  "order.address.city": "Town",
  "order.address.country": "Country",
  "order.address.fromBook": "Choose from your addresses",
  "order.address.other": "Choose another address",
  "order.address.search_one": "Search your {{count}} address",
  "order.address.search_other": "Search your {{count}} addresses",
  "order.address.new": "Another address",
  "order.address.all_one": "All {{count}} addresses",
  "order.address.all_other": "All {{count}} addresses",
  "order.address.mostUsed": "most used first",
  "order.address.noneFound": "None of your addresses matches your search.",
  "order.hours.always": "always open",
  "order.hours.open": "open {{hours}}",
  "order.hours.closed": "closed that day",
  "order.stop.load": "Loading",
  "order.stop.unload": "Unloading",
  "order.stop.newChip": "New address",
  "order.stop.newShort": "new",
  "order.stop.newWarning": "New address: your order waits for Willems. Willems checks a new address first and records it; then the order goes ahead.",
  "order.stop.date": "Date",
  "order.stop.from": "Window from",
  "order.stop.to": "until",
  "order.stop.endsBeforeStart": "The end time is before the start time. Change the time, or tick below that the window runs on to the next day.",
  "order.stop.nextDay": "The window runs on to the next day",
  "order.stop.loadReference": "Reference for loading",
  "order.stop.unloadReference": "Reference for unloading",
  "order.stop.requirement": "Vehicle requirement",
  "order.stop.requirementNone": "None",
  "order.stop.instruction": "Note for the driver",
  "order.stop.contactName": "Contact person",
  "order.stop.contactPhone": "Phone",
  "order.stopRequirement.tail_lift": "Tail lift",
  "order.stopRequirement.rigid_with_tail_lift": "Rigid truck with tail lift",
  "order.stopRequirement.no_rear_tail_lift": "No rear tail lift",
  "order.note.outside_hours": "The window is outside the opening hours ({{hours}}). Willems looks at it; the order goes ahead.",
  "order.note.closed_that_day": "This place is closed that day. Willems looks at it; the order goes ahead.",
  "order.note.window_in_past": "This day has already passed.",
  "order.goods.titleTo": "Cargo to {{place}}",
  "order.goods.count": "Number",
  "order.goods.carrier": "Carrier",
  "order.goods.description": "Description of goods",
  "order.goods.weight": "Weight (kg)",
  "order.goods.loadingMeters": "Loading metres",
  "order.goods.removeLine": "Remove line",
  "order.goods.addLine": "Another line",
  "order.goods.requirements": "Transport requirements",
  "order.goods.together": "Together",
  "order.goods.pallets_one": "{{n}} pallet",
  "order.goods.pallets_other": "{{n}} pallets",
  "order.goods.metres": "{{n}} loading metres",
  "order.goods.volume": "Volume (m³)",
  "order.goods.volumeValue": "{{n}} m³",
  "order.goods.adrCode": "ADR code",
  "order.goods.adrCodeChoose": "Choose the ADR code",
  "order.goods.adrClass": "class {{value}}",
  "order.goods.adrPackingGroup": "Packing group",
  "order.goods.adrLines": "Dangerous goods (ADR)",
  "order.goods.adrPackingGroupChoose": "Choose",
  "order.goods.adrQuantity": "Quantity",
  "order.goods.adrUnit": "Unit",
  "order.goods.adrAddLine": "Another ADR substance",
  "order.goods.adrRemoveLine": "Remove line",
  "order.goods.addConsignment": "Another shipment in this order, to another address",
  "order.goods.removeConsignment": "Remove shipment",
  "order.carrier.europallet": "Euro pallet",
  "order.carrier.block_pallet": "Block pallet 0.5 lm",
  "order.carrier.block_pallet_06": "Block pallet 0.6 lm",
  "order.carrier.block_pallet_09": "Block pallet 0.9 lm",
  "order.carrier.ibc_02": "IBC 0.2 lm",
  "order.carrier.ibc_04": "IBC 0.4 lm",
  "order.carrier.ibc": "IBC 0.5 lm",
  "order.carrier.ibc_06": "IBC 0.6 lm",
  "order.carrier.big_bag": "Big bag 0.5 lm",
  "order.carrier.roll_container": "Roll container",
  "order.carrier.box": "Packages or boxes",
  "order.carrier.other": "Other",
  "order.carrier.own": "Your carriers",
  "order.carrier.fixed": "Standard",
  "order.cmr.title": "On the CMR",
  "order.cmr.lead": "The sender and consignee can differ from the loading and unloading address.",
  "order.cmr.sender": "Sender",
  "order.cmr.consignee": "Consignee",
  "order.cmr.yourCompany": "Your company, as Willems knows it",
  "order.cmr.sameAsUnload": "Same as the unloading address",
  "order.cmr.theUnloadAddress": "the unloading address",
  "order.cmr.other": "Another address",
  "order.slip.label": "Packing slip",
  "order.slip.help": "A PDF, for example your packing slip, up to 10 MB. You will find it again with the shipment.",
  "order.slip.add": "Add packing slip",
  "order.slip.uploading": "Adding…",
  "order.slip.remove": "Remove {{name}}",
  "order.slip.tooLarge": "This file is larger than 10 MB.",
  "order.slip.notPdf": "Only a PDF can be added as a packing slip.",
  "order.slip.tooMany": "At most {{max}} per shipment.",
  "order.slip.failed": "Adding it did not work. Please try again.",
  "order.slip.gone": "A packing slip was no longer with us. Please add it again and then send the order.",
  "order.check.title": "This is how the order goes to Willems",
  "order.check.change": "Change",
  "order.check.willWait": "This order will wait for Willems.",
  "order.rail.title": "Your order",
  "order.rail.step": "step {{n}}",
  "order.rail.loadN": "Loading {{n}}",
  "order.rail.unloadN": "Unloading {{n}}",
  "order.rail.goods": "Cargo",
  "order.notice.title": "Before you send",
  "order.notice.newAddress": "New address: the order waits until Willems has checked the address.",
  "order.notice.inTime": "In time for loading on {{load}}: you can enter it until {{until}}.",
  "order.notice.late": "After the cut-off time ({{time}} the day before loading). Willems checks whether it can still be done.",
  "order.notice.referenceTaken": "Your reference is already on order {{order}}. Please choose another.",
  "order.savedAt": "Draft saved at {{time}}",
  "order.notSavedYet": "Saved while you type",
  "order.saveAndClose": "Save and close",
  "order.previous": "Previous",
  "order.next": "Next: {{step}}",
  "order.send": "Send order",
  "order.sendChange": "Send change",
  "order.sendAgain": "Send again",
  "order.sending": "Sending …",
  "order.failure.title": "Sending did not work",
  "order.failure.text": "Your order was not sent; what you entered is still here. Please try again. If it does not work, contact your contact person.",
  "order.failure.textCode": "Your order was not sent; what you entered is still here. Please try again. If it does not work, give code {{code}} to your contact person.",
  "order.error.too_many_pallets": "More than 99 pallet places in one shipment. Spread the cargo over more shipments.",
  "order.error.too_heavy": "More than 60,000 kg in one shipment. Spread the cargo over more shipments.",
  "order.error.too_long": "More than 30 loading metres in one shipment. Spread the cargo over more shipments.",
  "order.sent.at": "Sent at {{time}}",
  "order.sent.changedAt": "Changed at {{time}}",
  "order.sent.title": "Order {{number}} is with Willems",
  "order.sent.changedTitle": "Order {{number}} has been changed",
  "order.sent.confirmed": "Willems has the order and is planning it.",
  "order.sent.toShipment": "To the shipment",
  "order.sent.another": "Enter another order",
  "order.sent.sameAgain": "The same order for another day",
  "order.earlier.open": "Start from an earlier order",
  "order.earlier.title": "Start from an earlier order",
  "order.earlier.lead": "The portal takes over the addresses, windows, cargo and transport requirements. You fill in the dates and your reference.",
  "order.earlier.search": "Search by order, your reference or town",
  "order.earlier.order": "Order",
  "order.earlier.route": "Route",
  "order.earlier.take": "Use this one",
  "order.earlier.none": "No orders found.",
  "order.notAvailable": "Entering orders in the portal is for customers of Willems. Please contact your contact person.",
  "order.notChangeable.closed": "This order was rejected or cancelled and can no longer be changed.",
  "order.notChangeable.elsewhere": "This order was not entered in the portal. Change it the way it came in, or through your contact person at Willems.",
  "order.notChangeable.planned": "This order is planned. It can now only be changed through your contact person at Willems.",
  "order.notChangeable.pending": "Willems is still processing a change to this order. Try again later, or contact your contact person.",
  "order.notChangeable.transition": "This order was entered before 1 December. Change or cancel it through your contact person at Willems.",
  "order.change": "Change",
  "order.changeUntil": "Possible until the shipment is planned.",
  "order.again": "Enter again for another day",
  "order.cancel.open": "Cancel",
  "order.cancel.title": "Cancel order {{number}}",
  "order.cancel.lead": "The whole order is cancelled, with all its shipments. Willems reads your reason.",
  "order.cancel.reason": "Why are you cancelling?",
  "order.cancel.back": "Back",
  "order.cancel.confirm": "Cancel order",
  "order.cancel.tooLate": "This order can no longer be cancelled in the portal. Please contact your contact person.",

  "error.loginFailed": "E-mail address or password is not right. Mind capitals. After five times, signing in is locked for a quarter of an hour.",
  "error.locked": "Your account is locked for a quarter of an hour after five attempts that were not right. You can try again at {{time}}.",
  "error.codeWrong": "This code is not right. Type the code the app shows now.",
  "error.setupIncomplete": "Your account is not set up yet. Use the link in the invitation; if it no longer works, ask your contact person at Willems for a new one.",
  "error.linkInvalid": "This link no longer works.",
  "error.currentPasswordWrong": "This password is not right.",
  "error.signInAgain": "That took too long. Please sign in again.",
  "error.secondFactorOff": "Linking the app is not possible here yet. Contact your contact person at Willems.",
  "error.tooMany": "Too many attempts from this address. Wait a minute and try again.",
  "error.generic": "Something went wrong. Please try again in a moment.",

  // Voorraad (H-v01 … H-v06, step 7).
  "stock.asOf": "As of",
  "stock.inWarehouse": "warehouse {{name}}",
  "stock.inWarehouses_one": "{{count}} warehouse",
  "stock.inWarehouses_other": "{{count}} warehouses",
  "stock.fetching": "Fetching the stock",
  "stock.noStand": "No stock figures",
  "stock.refresh": "Refresh",
  "stock.excel": "Excel per pallet",
  "stock.views": "Which articles",
  "stock.view.all": "All articles",
  "stock.view.short": "Best before within 9 months",
  "stock.view.blocked": "Blocked",
  "stock.search": "Article, batch, SSCC or LHC",
  "stock.searchShort": "Search an article",
  "stock.owner": "Owner",
  "stock.allOwners": "All owners",
  "stock.warehouse": "Warehouse",
  "stock.allWarehouses": "All warehouses",
  "stock.loading": "Fetching the stock from the warehouse. This takes a few seconds.",
  "stock.failedTitle": "The stock cannot be fetched right now.",
  "stock.failedText": "Please try again in a few minutes. We do not show older figures: they may no longer be right.",
  "stock.failedCode": "Still failing? Quote code {{code}} to your contact at Willems.",
  "stock.busyTitle": "It is busy right now.",
  "stock.busyText": "Many stock requests are coming in at the moment. Please try again in a minute.",
  "stock.refreshIn": "Refresh in {{seconds}} s",
  "stock.retryIn": "Try again in {{seconds}} s",
  "stock.emptyTitle": "You have no stock at Willems right now.",
  "stock.emptyText": "As soon as pallets come in, they show here.",
  "stock.notFound": "Nothing found for “{{q}}”.",
  "stock.none.all": "No articles with these filters.",
  "stock.none.short": "No pallets with a best-before within 9 months.",
  "stock.none.blocked": "No blocked pallets.",
  "stock.showAll": "Show all",
  "stock.col.article": "Article",
  "stock.col.total": "Total",
  "stock.col.free": "Available",
  "stock.col.reserved": "Reserved",
  "stock.col.blocked": "Blocked",
  "stock.col.shortest": "Best before (shortest)",
  "stock.col.bestBefore": "Best before",
  "stock.col.sscc": "SSCC",
  "stock.col.batch": "Batch",
  "stock.col.lhc": "LHC",
  "stock.col.quantity": "Quantity",
  "stock.col.status": "Status",
  "stock.col.received": "Received",
  "stock.shortPallets_one": "{{count}} pallet < 9 mo",
  "stock.shortPallets_other": "{{count}} pallets < 9 mo",
  "stock.months_one": "{{count}} mo",
  "stock.months_other": "{{count}} mo",
  "stock.palletsWhere": "in {{where}} · blocked first, then the shortest best-before",
  "stock.status.free": "Available",
  "stock.status.reserved": "Reserved",
  "stock.status.blocked": "Blocked",
  "stock.split": "Available {{free}}, reserved {{reserved}}, blocked {{blocked}}",
  "stock.freeShort": "Available {{n}}",
  "stock.reservedShort": "Res. {{n}}",
  "stock.blockedShort": "Blocked {{n}}",

  // Uitleveren en Aanleveren (H-w01 … H-w03, step 8).
  "warehouseOrder.kindLabel": "Kind of order",
  "warehouseOrder.kind.transport": "Transport only",
  "warehouseOrder.kind.outbound": "Ship from our warehouse",
  "warehouseOrder.kind.inbound": "Deliver to our warehouse",
  "warehouseOrder.kindShort.transport": "Transport",
  "warehouseOrder.kindShort.outbound": "Outbound",
  "warehouseOrder.kindShort.inbound": "Inbound",
  "warehouseOrder.loading": "Fetching your articles and warehouses.",
  "warehouseOrder.noWarehouse": "You have no stock at Willems right now.",
  "warehouseOrder.noWarehouseText": "Would you like to deliver a new article? Please contact your contact at Willems.",
  "warehouseOrder.articles": "Articles",
  "warehouseOrder.ownArticles_one": "{{count}} of your articles",
  "warehouseOrder.ownArticles_other": "{{count}} of your articles",
  "warehouseOrder.unit": "Unit",
  "warehouseOrder.uom.PCE_one": "piece",
  "warehouseOrder.uom.PCE_other": "pieces",
  "warehouseOrder.uom.ST_one": "piece",
  "warehouseOrder.uom.ST_other": "pieces",
  "warehouseOrder.uom.CT_one": "box",
  "warehouseOrder.uom.CT_other": "boxes",
  "warehouseOrder.uom.BX_one": "box",
  "warehouseOrder.uom.BX_other": "boxes",
  "warehouseOrder.uom.BG_one": "bag",
  "warehouseOrder.uom.BG_other": "bags",
  "warehouseOrder.uom.BD_one": "bundle",
  "warehouseOrder.uom.BD_other": "bundles",
  "warehouseOrder.uom.KT_one": "kit",
  "warehouseOrder.uom.KT_other": "kits",
  "warehouseOrder.uom.PF_one": "pallet",
  "warehouseOrder.uom.PF_other": "pallets",
  "warehouseOrder.uom.KGM_one": "kilo",
  "warehouseOrder.uom.KGM_other": "kilos",
  "warehouseOrder.stockAsOf": "Stock as of {{time}}",
  "warehouseOrder.stockFailed": "The stock cannot be fetched right now. You can type the article number yourself.",
  "warehouseOrder.stockLoading": "Fetching the stock…",
  "warehouseOrder.chooseOwner": "Choose an owner",
  "warehouseOrder.article": "Article",
  "warehouseOrder.searchArticle": "Type an article number or description",
  "warehouseOrder.noArticleFound": "No article found",
  "warehouseOrder.moreArticles_one": "{{count}} more article: keep typing to search",
  "warehouseOrder.moreArticles_other": "{{count}} more articles: keep typing to search",
  "warehouseOrder.freeShort": "available {{n}} {{unit}}",
  "warehouseOrder.notListed": "Not an article from the list: choose the article",
  "warehouseOrder.quantity": "Quantity {{unit}}",
  "warehouseOrder.batch": "Batch",
  "warehouseOrder.pallets": "Pallets",
  "warehouseOrder.choosePallets": "Choose pallets",
  "warehouseOrder.palletsChosen_one": "{{count}} pallet",
  "warehouseOrder.palletsChosen_other": "{{count}} pallets",
  "warehouseOrder.palletsHint": "Tick the pallets you want delivered. The quantity becomes what is on them.",
  "warehouseOrder.palletsHintBatch": "Tick the pallets of batch {{batch}} you want delivered. The quantity becomes what is on them.",
  "warehouseOrder.noPalletsOfBatch": "There are no free pallets of this batch.",
  "warehouseOrder.palletNumber": "Pallet no. {{n}}",
  "warehouseOrder.bestBefore": "BBD {{date}}",
  "warehouseOrder.perPallet": "Per pallet",
  "warehouseOrder.removeLine": "Remove",
  "warehouseOrder.moreThanFree": "More than is available ({{free}} {{unit}}). You can send it all the same; Willems will contact you.",
  "warehouseOrder.addLine": "Add an article",
  "warehouseOrder.howOut": "How does it leave {{warehouse}}?",
  "warehouseOrder.howIn": "How does it get to {{warehouse}}?",
  "warehouseOrder.transport.outbound.willems": "Willems delivers it",
  "warehouseOrder.transport.outbound.customer": "It is collected",
  "warehouseOrder.transport.inbound.willems": "Willems collects it",
  "warehouseOrder.transport.inbound.customer": "It is brought in",
  "warehouseOrder.dayOut": "Day it leaves our warehouse",
  "warehouseOrder.dayIn": "Day it arrives",
  "warehouseOrder.load": "What the transport carries",
  "warehouseOrder.remark": "Remark for the warehouse",
  "warehouseOrder.orderLabel": "Your order",
  "warehouseOrder.deliverTo": "Deliver to",
  "warehouseOrder.collectedAddressHint": "Where do the goods go? This goes on the consignment note (CMR).",
  "warehouseOrder.collectFrom": "Collect from",
  "warehouseOrder.forWarehouse": "For the warehouse",
  "warehouseOrder.vas": "VAS",
  "warehouseOrder.vasOrder": "VAS for the whole order",
  "warehouseOrder.vasLine": "VAS for {{article}}",
  "warehouseOrder.vasChoose": "Choose",
  "warehouseOrder.beforeSending": "Before you send: for {{articles}} you ask more than is available. Willems will contact you.",
  "warehouseOrder.send": "Send order",
  "warehouseOrder.sending": "Sending…",
  "warehouseOrder.sent.title": "Order {{number}} has been sent",
  "warehouseOrder.sent.withTransport": "The warehouse prepares it and Willems drives it. Follow the shipment under Shipments.",
  "warehouseOrder.sent.withoutTransport": "The warehouse has your order. Willems will contact you if anything is not right.",
  "warehouseOrder.sent.toShipment": "To the shipment",
  "warehouseOrder.sent.another": "Another order",
  "warehouseOrder.sent.toOrders": "To your warehouse orders",

  "warehouseOrders.lead": "Your outbound and inbound orders of the last 90 days, also those collected or brought.",
  "warehouseOrders.loading": "Fetching your warehouse orders.",
  "warehouseOrders.views": "Which orders",
  "warehouseOrders.view.all": "All",
  "warehouseOrders.view.outbound": "Outbound",
  "warehouseOrders.view.inbound": "Inbound",
  "warehouseOrders.search": "Reference, order number or article",
  "warehouseOrders.searchShort": "Search",
  "warehouseOrders.col.order": "Your reference",
  "warehouseOrders.col.kind": "Type",
  "warehouseOrders.col.warehouse": "Warehouse",
  "warehouseOrders.col.day": "Day",
  "warehouseOrders.col.transport": "Transport",
  "warehouseOrders.col.articles": "Articles",
  "warehouseOrders.col.status": "Status",
  "warehouseOrders.col.quantity": "Quantity",
  "warehouseOrders.col.pallet": "Pallet",
  "warehouseOrders.moreArticles_one": "and {{count}} other article",
  "warehouseOrders.moreArticles_other": "and {{count}} other articles",
  "warehouseOrders.status.sent": "Sent",
  "warehouseOrders.status.received": "At the warehouse",
  "warehouseOrders.status.waiting": "Willems is looking at it",
  "warehouseOrders.deliveryDay": "Requested delivery day",
  "warehouseOrders.goesTo": "Goes to",
  "warehouseOrders.enteredPortal": "Entered in the portal on {{at}}",
  "warehouseOrders.enteredWillems": "Entered by Willems on {{at}}",
  "warehouseOrders.emptyTitle": "No warehouse orders yet",
  "warehouseOrders.emptyText": "An outbound or inbound order you enter appears here.",
  "warehouseOrders.notFound": "Nothing found for “{{q}}”",
  "warehouseOrders.none.all": "No warehouse orders",
  "warehouseOrders.none.outbound": "No outbound orders",
  "warehouseOrders.none.inbound": "No inbound orders",
  "warehouseOrders.transport.willems": "With Willems",
  "warehouseOrders.transport.customer": "Collected or brought",
  "warehouseOrders.notFiltered": "No warehouse orders with these filters",
  "warehouseOrders.showAll": "Show all",
};
